import React, { useState, useEffect, useRef } from 'react';
import {useHistory} from 'react-router-dom';
import Tooltip from '../../tooltip/Tooltip';
import {useDispatch} from "react-redux";
import {updateCompanyInfo} from "../../../../store/reducers/companyInfoReducer";
import api from "../../../../constants/api";
import LoadingSpinner from "../../../common/LoadingSpinner";
import {recaptchaSiteKey} from "../../../../constants";

function CompanyListItem({ company }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const [openSafeNo, setOpenSafeNo] = useState(false);
    const [openReg, setOpenReg] = useState(false);
    const [tooltipClassReg, setTooltipClassReg] = useState("more_info-list");
    const [tooltipClassSafeNo, setTooltipClassSafeNo] = useState("more_info-list");
    const alreadyExistsLink = "/alreadyRegistered";
    const [isLoading, setIsLoading] = useState(false);

    const span1 = useRef();
    const span2 = useRef();

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
      }, []);

    const selectCompany = async () => {
        setIsLoading(true);

        const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'find_company'})
        const result = await api.findAgiloftCompany(company.registrationNumber || company.safeNumber, token);

        if (result.errors) {
            setIsLoading(false);
            return;
        }

        if (result.exists) {
            history.push(alreadyExistsLink);
            return;
        }

        setIsLoading(false);

        dispatch(updateCompanyInfo(company));
        history.push("/form");
    }

    const handleClick = e => {
        if (span1.current.contains(e.target)) {
            setOpenReg(true)
            setTooltipClassReg("more_info-active")
            setTooltipClassSafeNo("more_info-list")
            setOpenSafeNo(false)
            return;
        } else if(span2.current.contains(e.target)) {
            setOpenSafeNo(true)
            setTooltipClassSafeNo("more_info-active")
            setOpenReg(false)
            setTooltipClassReg("more_info-list")
            return;
        }
        setOpenReg(false)
        setTooltipClassReg("more_info-list")
        setTooltipClassSafeNo("more_info-list")
        setOpenSafeNo(false)
    };

    return (
        <>
            <div className="list-divider"></div>
            <div className="company-search_container">
                <div className="label_container">
                    <p>Company</p>
                    <p>Org No<span ref={span1} className={tooltipClassReg}
                        onClick={handleClick}
                    >                  
                        {openReg && (
                            <Tooltip title="Organisation number" text="The company's organisation number in the Brønnøysund Register."/>
                        )}
                    </span></p>

                    <p>Connect ID<span ref={span2} className={tooltipClassSafeNo}
                        onClick={handleClick}
                    > 
                        {openSafeNo && (
                            <Tooltip title="Connect ID" text="The Connect ID is a unique number that identifies business entities on a location-specific basis. Assigned and maintained by Creditsafe, Connect ID is widely used as a standard business identifier."/>
                        )}
                    </span></p>
                    <p>Address</p>
                </div>
                <div className="companyInfo_container" onClick={selectCompany}>
                    <p className="company-name">{company.name}</p>
                    <p>{company.registrationNumber}</p>
                    <p className="safeno">{company.safeNumber}</p>
                    <p>{company.addressConcatenated}</p>
                    <div className="selectButton">
                        <button className="plausible-event-name=Registration+Select+Company" disabled={isLoading}>{isLoading ? <LoadingSpinner light={true} small={true}/> : "Select and continue"}</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompanyListItem;
